// Schema used for retrieving a coach
export const getProfileSchema = `
  coachProfileId
  firstName
  lastName
  displayName
  title
  gender
  profilePhoto
  customSlug
  city
  state
  zipCode
  bio
  numberOfStudents
  numberOfFollowers
  # TODO(coach-tenure): Coach Tools CoachProfiles (this document) has
  # no join date, election year, memberSince, or yearsActive field.
  # Nested coach.pgaMembership is MembershipMember (membershipStatus,
  # memberClass, certificationLevel, …) — also no tenure.
  # PGAMembership.activeMember is a boolean only. Do not select
  # yearsOfPgaMembership until the resolver exposes it; a missing
  # field errors the query. When a positive integer does arrive, the
  # bio membership banner puts it in the first sentence and the
  # reserved stats strip still renders. See coach-bio.jsx PropTypes.
  bookingUrl
  bookable
  status
  certificationLevel
  memberType
  # ADM (American Development Model) certification from membership — false when
  # the coach has no membership record (Coach Tools CoachProfile#admCertified).
  admCertified
  socialJsonData {
    type
    reference
    preferred
  }
  testimonialsJsonData {
    testimonial
    author
    rank
  }
  photosJsonData {
    reference
    rank
  }
  toolJsonData
  facilities {
    facilityId
    pgaFacilityId
    facilityName
    street
    city
    state
    zipCode
    phoneNumber
    website
    isPrivate
    customData {
      facilityRank
      description
      photos
      offerings {
        name
        description
      }
      offersCoachingAtPrivateClub
    }
  }
  experienceTypes {
    experienceTypeId
    typeName
    description
    experiences {
      experienceId
      experienceName
      experienceType
    }
  }
  serviceTypes {
    serviceTypeId
    typeName
    description
    services {
      serviceId
      serviceName
      serviceType
    }
  }
  skills {
    skillId
    skillName
    description
  }
  coach {
    pgaCoachEligible
    canPromoteContent
    id
    pgaHopeCoach
    freeTierLimitsReached
    preferences {
      bookNowEnabled
      acceptsLeads
    }
    lessonTypes {
      id
      status
    }
    hasPaidTierSubscription
  }
  universalId
  introductionVideoUrl
`
